module.exports = __webpack_public_path__ + "img/boncard.c51aff2a.svg";